import { gql } from "@apollo/client";

export const ORDER_BILLABLE_ITEM_FIELDS = gql`
  fragment OrderBillableItemFields on BillableItem {
    id
    displayId
    name
    amount
    unit
  }
`;

export const GET_SHIPMENT_ORDER_BILLABLE_ITEM = gql`
  query GetShipmentOrderBillableItem($courierId: ID!, $shipmentId: ID!) {
    shipmentById(courierId: $courierId, shipmentId: $shipmentId) {
      id
      order {
        id
        endCustomer {
          id
        }
        billableItem {
          ...OrderBillableItemFields
        }
      }
    }
  }
  ${ORDER_BILLABLE_ITEM_FIELDS}
`;

export const GET_TEMPLATE_ORDER_BILLABLE_ITEM = gql`
  query GetTemplateOrderBillableItem(
    $courierId: ID!
    $shipmentTemplateId: ID!
  ) {
    shipmentTemplateById(
      courierId: $courierId
      shipmentTemplateId: $shipmentTemplateId
    ) {
      id
      order {
        id
        endCustomer {
          id
        }
        billableItem {
          ...OrderBillableItemFields
        }
      }
    }
  }
  ${ORDER_BILLABLE_ITEM_FIELDS}
`;

/**
 * The items an order can be billed under.
 *
 * endCustomerIdFilter is non-null on purpose: the backend returns the courier's whole
 * catalogue when it is omitted, and the picker must only ever offer items the assignment
 * mutation will accept. Callers must not run this query before the end customer is known.
 */
export const GET_ASSIGNABLE_BILLABLE_ITEMS = gql`
  query GetAssignableBillableItems(
    $courierId: ID!
    $endCustomerIdFilter: ID!
    $after: Int
    $limit: Int
  ) {
    billableItemsPaginated(
      courierId: $courierId
      endCustomerIdFilter: $endCustomerIdFilter
      after: $after
      limit: $limit
    ) {
      edges {
        node {
          ...OrderBillableItemFields
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
  ${ORDER_BILLABLE_ITEM_FIELDS}
`;

export const ASSIGN_BILLABLE_ITEM_TO_ORDER = gql`
  mutation AssignBillableItemToOrder(
    $courierId: ID!
    $orderId: ID!
    $billableItemId: ID
  ) {
    assignBillableItemToOrder(
      courierId: $courierId
      orderId: $orderId
      billableItemId: $billableItemId
    ) {
      id
      billableItem {
        ...OrderBillableItemFields
      }
    }
  }
  ${ORDER_BILLABLE_ITEM_FIELDS}
`;
